"use client";

import { useTenant } from "@tillix/tenants/react";
import { BaseFieldLabel, type BaseFieldLabelProps } from "./field-label";
import ConEdisonFieldLabel from "./field-label.con-edison";
import type { OptionalTenantProp } from "../../../../types";

export function FieldLabel(props: BaseFieldLabelProps & OptionalTenantProp) {
  const contextTenant = useTenant();

  const tenantRefId = props.tenant?.id ?? contextTenant?.id;
  const tenantVariantId = (props.tenant?.variantId ??
    contextTenant?.variantId) as "oru-reco" | null | undefined;

  switch (tenantRefId) {
    case "con-edison":
      return (
        <ConEdisonFieldLabel
          {...props}
          tenantVariant={tenantVariantId ?? undefined}
        />
      );

    default:
      return <BaseFieldLabel {...props} />;
  }
}
